module.exports = __webpack_public_path__ + "components/country-flag/static/fo-b9ed9169e6b272e1a08078e636ca199f.svg";